import Page from '../common/page.js'

const state = Object.assign({}, Page.state)
state.endpoint = 'containers'

export default {
  namespaced: true,
  state,
  getters: Page.getters,
  mutations: Page.mutations,
  actions: Page.actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/containers/containers.js